import { useEffect, useState } from "react";
import { fetchTables } from "../../api/application/table";
import type { APITable } from "../../api/infrastructure/table.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";

export default function useGetTables({
  referenceId,
  preloadData = true,
}: {
  referenceId?: number;
  preloadData?: boolean;
} = {}) {
  const [tables, setTables] = useState<APITable[]>([]);
  const [loading, setLoading] = useState(false);

  const fetch = async (refId: number) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      const result = await fetchTables(refId);
      setTables(result);
    });
    setLoading(false);
  };

  const filterTables = (query: string): APITable[] => {
    if (!query.trim()) return tables;
    return tables.filter(
      (table) =>
        table.label.toLowerCase().includes(query.toLowerCase()) ||
        table.name.toLowerCase().includes(query.toLowerCase()),
    );
  };

  useEffect(() => {
    if (preloadData && referenceId) {
      fetch(referenceId);
    }
  }, [referenceId, preloadData]);

  return {
    tables,
    loadingTables: loading,
    refreshTables: fetch,
    filterTables,
  };
}
